export default __webpack_public_path__ + "static/media/dice-3.7277b185.svg";